// extracted by mini-css-extract-plugin
export var alignDiscLeft = "n_qq d_fp d_bG d_dv";
export var alignLeft = "n_qh d_fp d_bG d_dv";
export var alignDiscCenter = "n_qr d_fq d_bD d_dw";
export var alignCenter = "n_bP d_fq d_bD d_dw";
export var alignDiscRight = "n_qs d_fr d_bH d_dx";
export var alignRight = "n_qj d_fr d_bH d_dx";
export var footerContainer = "n_qt d_dW d_bW";
export var footerContainerFull = "n_qv d_dT d_bW";
export var footerHeader = "n_kf d_kf";
export var footerTextWrapper = "n_qw d_w";
export var footerDisclaimerWrapper = "n_km d_km d_ck";
export var badgeWrapper = "n_qx d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "n_qy d_bz d_bJ d_bN d_bL";
export var wide = "n_qz d_cy";
export var right = "n_qB d_bK";
export var line = "n_fk d_fl d_cv";
export var badgeDisclaimer = "n_qC d_bC d_bP d_bJ";
export var badgeContainer = "n_qD d_bz d_bH d_bP";
export var badge = "n_qF";
export var padding = "n_qG d_c7";
export var end = "n_qH d_bH";
export var linkWrapper = "n_qJ d_dB";
export var link = "n_mC d_dB";
export var colWrapper = "n_qK d_cx";
export var consent = "n_f d_f d_bC d_bP";
export var disclaimer = "n_qL d_bz d_bJ";
export var media = "n_qM d_bx d_dy";
export var itemRight = "n_qN";
export var itemLeft = "n_qP";
export var itemCenter = "n_qQ";
export var exceptionWeight = "n_qR r_rM";